$(document).ready(function(){

$('#checkB').click(function(){
   $(this).toggleClass("active");
    let getAdd = $(this).parents('.product-page--form').find('.product-buy-buttons--root');
    $('#btnId').toggleClass("actbtn");
    
    $('#btnId').click(function(){      
      $("#addToCarBtn").click();
    })  
    $(getAdd).toggleClass("removeBtn");

})

// fancybox
$('[data-fancybox]').fancybox({
 });



// $(".product-images .imgItem").each(function(a) {
// $(this).addClass("prdimg-"+(a+0)); 
// });
// $(".prdimg-0, .prdimg-1").wrapAll("<div class='prdgalimg-col prdgalimg-col-1'></div>");
// $(".prdimg-2, .prdimg-3, .prdimg-4").wrapAll("<div class='prdgalimg-col prdgalimg-col-2'></div>");
// $(".prdgalimg-col-2").nextAll().wrapAll("<div class='prdgalimg-col prdgalimg-col-3'></div>");


// custom slider
  
$('.prodImagesSlider').each(function() {
  $(this).slick({
    slidesToShow: 1,
    infinite: false,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 2000,
    fade: true,
    prevArrow: $(this).parents('.productSliderSec').find('.prev-arrow'),
    nextArrow: $(this).parents('.productSliderSec').find('.next-arrow')
  });
});




  // Add smooth scrolling to all links
  $("a").on('click', function(event) {

    // Make sure this.hash has a value before overriding default behavior
    if (this.hash !== "") {
      // Prevent default anchor click behavior
      event.preventDefault();

      // Store hash
      var hash = this.hash;

      // Using jQuery's animate() method to add smooth page scroll
      // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
      $('html, body').animate({
        scrollTop: $(hash).offset().top - 100
      }, 800, function(){
   
        // Add hash (#) to URL when done scrolling (default click behavior)
        window.location.hash = hash;
      });
    } // End if
  });

  var getHtml = $('.header--top-row .rightMenu').html();
  

  $('.drawer--root .mobile-nav .mobile-nav--menu .y-menu .y-menu--level-1--container').append(getHtml);



// product details page collapse row

  $('[data-block-type="collapsible-row"]').wrapAll('<div class="accordionBlock"></div>');
  $('.accordionBlock .product-page--block:first-child').addClass('active');

  
 $(document).ready(function(){       
  $('.accordionBlock .collapsible-row--content-wrapper').css('height','auto');
   
  var getHeight = $('.accordionBlock .collapsible-row--content-wrapper').height();   
   getHeight = getHeight + 'px';
   $('.accordionBlock .product-page--block').css('--height',getHeight);
   
  $('.accordionBlock .product-page--block .collapsible-row--toggle').click(function(){
    if($(this).parents('.product-page--block').hasClass('active')){
        $(this).parents('.product-page--block').removeClass('active');        
    }else{
        $('.accordionBlock .product-page--block').removeClass('active');
        $('.accordionBlock .product-page--block').children('.collapsible-row--content-wrapper').css('height','0');
        $(this).parents('.product-page--block').addClass('active');

    }   
 })
 })



// Product details slick slider
$('.sliderMain').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  fade: true,
  asNavFor: '.sliderThumb',
  prevArrow: '<button type="button" class="slick-arrow arrow-prev"> <svg width="11" height="20" viewBox="0 0 11 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.85713 18.2687L2.33713 11.7487C1.56713 10.9787 1.56713 9.71865 2.33713 8.94865L8.85713 2.42865" stroke="#08C0DE" stroke-width="3.42857" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/></svg> </button>',
  nextArrow: '<button type="button" class="slick-arrow arrow-next"> <svg width="11" height="20" viewBox="0 0 11 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.85718 18.2687L8.37718 11.7487C9.14718 10.9787 9.14718 9.71865 8.37718 8.94865L1.85718 2.42865" stroke="#08C0DE" stroke-width="3.42857" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/></svg> </button>',
  adaptiveHeight: true
  
});
$('.sliderThumb').slick({
  slidesToShow: 4,
  slidesToScroll: 1,		
  asNavFor: '.sliderMain',
  centerMode: false,
  focusOnSelect: true,
  arrows: false,   
  margin:20,
  // prevArrow: ".thumb-prev",
  //nextArrow: ".thumb-next",
	});
  

                                                             
// read more add
  $('.section--product-page .product-page--description').each(function(){     
      $(this).wrapInner('<div class="description_content"></div>'); 
      let xPos =  $(this).find('.description_content').position().top;
      $(this).find('.description_content *').removeAttr('style');
    $(this).find('.description_content *').removeAttr('class');
  
      $(this).find('.description_content').clone().appendTo(this);
      var getContHeight =  $(this).find('.description_content + .description_content').height();
        getContHeight = getContHeight + 'px';
      $(this).css('--height',getContHeight);
      
    if(true){         
      $(this).append('<span class="btn-read">Read More</span>');
      // read more click 
      $(this).find('.btn-read').click(function(){      
        $('html, body').animate({ scrollTop: xPos }, 500);
        $(this).parent().toggleClass('showContent');
        if($(this).text() == "Read More"){
              $(this).text("Read Less");
            
          }else{
              $(this).text("Read More");
            
          }
      });  
    } 
    
  });
  


  
})// Document End